import Loadable from 'react-loadable'
import { Component } from 'react'

import Loading from 'components/modulor/loading'

LoadableComponent = Loadable
  loader: -> `import('./width_input' /* webpackChunkName: "width_input" */)`,
  loading: -> <Loading />

export default class LoadableWidthInput extends Component
  render: -> <LoadableComponent {...this.props} />
